import React from 'react';
import AdminButton from '../../../components/admin/AdminButton';

const EstimateHelpModal = ({ onClose }) => {
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
            <div style={{
                background: 'white', padding: '30px', borderRadius: '8px',
                width: '700px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                    <h2 style={{ margin: 0, color: '#333' }}>📖 견적 설정 가이드</h2>
                    <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: '1.5rem', cursor: 'pointer' }}>&times;</button>
                </div>

                <div className="help-content">
                    <section style={{ marginBottom: '25px' }}>
                        <h3 style={{ color: '#007bff', borderLeft: '4px solid #007bff', paddingLeft: '10px' }}>1. 질문 유형별 특징</h3>
                        <p>옵션(선택지) 유무에 따라 화면 표시가 다릅니다.</p>
                        <ul style={{ background: '#f8f9fa', padding: '15px 25px', borderRadius: '5px' }}>
                            <li style={{ marginBottom: '8px' }}>
                                <strong>RADIO (단일선택) / CHECKBOX (다중선택)</strong>:
                                <br /> ⚠️ <strong>옵션이 없으면 아무것도 표시되지 않습니다.</strong> 반드시 하나 이상의 옵션을 추가해야 합니다.
                            </li>
                            <li style={{ marginBottom: '8px' }}>
                                <strong>SELECT (드롭다운)</strong>:
                                <br /> 옵션이 없어도 빈 드롭다운("선택해주세요")이 표시됩니다.
                            </li>
                            <li>
                                <strong>NUMBER (숫자) / TEXT (텍스트)</strong>:
                                <br /> ✅ <strong>옵션이 없어도 입력창은 항상 표시됩니다.</strong>
                                <br /> 옵션을 추가하면 해당 옵션의 이름이 입력창 옆에 <strong>라벨(단위 설명 등)</strong>로 표시되며, 가격 설정의 기준이 됩니다.
                            </li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '25px' }}>
                        <h3 style={{ color: '#28a745', borderLeft: '4px solid #28a745', paddingLeft: '10px' }}>2. 가격 자동 계산 로직</h3>
                        <p>질문 유형에 따라 수량(Quantity) 적용 방식이 다릅니다.</p>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px', fontSize: '0.9rem' }}>
                            <thead>
                                <tr style={{ background: '#eee' }}>
                                    <th style={{ border: '1px solid #ddd', padding: '8px' }}>구분</th>
                                    <th style={{ border: '1px solid #ddd', padding: '8px' }}>계산 공식</th>
                                    <th style={{ border: '1px solid #ddd', padding: '8px' }}>설명</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #ddd', padding: '8px', fontWeight: 'bold' }}>선택형 (Radio 등)</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>단가 × 설정 수량 (Multiplier)</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>'옵션 A' 선택 시 설정된 배수만큼 가격 부과</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #ddd', padding: '8px', fontWeight: 'bold' }}>입력형 (Number)</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>(사용자 입력 + 설정 수량) × 단가</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                        입력값에 <strong>Offset(가감)</strong>을 적용합니다.<br />
                                        예: 입력 10, 설정 -2 → (10-2) × 단가
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p style={{ marginTop: '10px', fontSize: '0.85rem', color: '#666' }}>
                            ※ 하나의 답변에 여러 가격 요소가 연결된 경우, 각각 계산된 금액이 합산됩니다.
                        </p>
                    </section>

                    <section>
                        <h3 style={{ color: '#dc3545', borderLeft: '4px solid #dc3545', paddingLeft: '10px' }}>3. 엑셀 관리 주의사항</h3>
                        <ul style={{ background: '#fff5f5', padding: '15px 25px', borderRadius: '5px' }}>
                            <li style={{ marginBottom: '8px' }}>
                                <strong>관리 범위</strong>: 엑셀은 <strong>질문 목록과 옵션 이름(구조)</strong>만 관리합니다. 가격 연결 정보는 엑셀에 포함되지 않습니다.
                            </li>
                            <li>
                                <strong>안전한 수정</strong>: 엑셀을 다시 업로드해도, <strong>옵션 이름이 기존과 동일하다면</strong> 웹에서 설정해둔 가격 정보는 <strong>유지(보존)</strong>됩니다.
                                <br /> (주의: 엑셀에서 옵션 이름을 변경하면 새로운 옵션으로 인식되어 기존 가격 설정이 초기화될 수 있습니다.)
                            </li>
                        </ul>
                    </section>
                </div>

                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                    <AdminButton
                        onClick={onClose}
                        variant="primary"
                        className="!bg-gray-800 hover:!bg-gray-900 border-transparent text-white px-8"
                    >
                        닫기
                    </AdminButton>
                </div>
            </div>
        </div>
    );
};

export default EstimateHelpModal;
